import { entity, list } from "./base";
import { concatModules } from "@/utility";

const initialEntity = {
  maker_id: null,
  maker_name: null,
  template_id: null,
  template_name: null,
  result_count: null
};

const templateEntityModule = {
  state: {
    selectedItems: [],
    fixedItem: '',
    answerItems: []
  },
  mutations: {
    selectedItems(state, payload) {
      state.selectedItems = payload.value;
    },
    fixedItem(state, payload) {
      state.fixedItem = payload.value;
    },
    answerItems(state, payload) {
      state.answerItems = payload.value;
    }
  },
  actions: {
    updateSelectedItems({ commit }, { value }) {
      // 質問の選択肢のみ保持しておく
      let selected = [];
      for (let i=1; i<=11; i++) {
        if (value[`review_item_${i}`]) {
          selected.push(value[`review_item_${i}`]);
        }
      }
      commit("selectedItems", {
        value: selected
      });
    },
    updateFixedItem({ commit }) {
      this.$axios.get(`options/review_items`, {
        params: {
          fixedItem: true
        }
      })
        .then((response) => {
          commit("fixedItem", {
            value: response.data.data.label
          });
        });
    },
    updateAnswerItem({ commit }) {
      this.$axios.get(`options/review_answers`)
        .then((response) => {
          commit("answerItems", {
            value: response.data.data
          });
        });
    }
  },
  getters: {
    selectedItems(state) {
      return state.selectedItems;
    },
    fixedItem(state) {
      return state.fixedItem;
    },
    answerItems(state) {
      return state.answerItems;
    }
  }
};

const entityModule = entity("templates", initialEntity);

export const templates = {
  namespaced: true,
  modules: {
    list: list("templates"),
    entity: concatModules(entityModule, templateEntityModule)
  }
};
